<template>
	<div class="show_con" style="margin: 20px 30px 0">
		<div id="wrap" v-cloak style="line-height: 27px;" >
      <div class="header">
        <p class="title">视力调理协议书</p>
      </div>
      <div class="content">
        <div>
          <div class="line"><b>甲方: {{ centre_info.centre }}</b></div>
          <div class="line">地址: {{ centre_info.site }}</div>
          <div class="information">
            <ul style="margin-right: 10px;">
              <li>
                <span><b>乙 &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;方:</b></span>
                <input type="text" disabled  v-model="users.baobao_name" placeholder="请输入会员姓名检索"/>
              </li>
              <li>
                <span><b>身份证号码:</b></span>
                <input type="text" disabled  v-model="users.id_number"/>
              </li>
              <li>
                <span><b>乙方监护人:</b></span>
                <input type="text" disabled  v-model="users.consignee_name"/>
              </li>
              <li>
                <span><b>身份证号码:</b></span>
                <input type="text" disabled  v-model="users.p_id_number"/>
              </li>
              <li style="width: 98%">
                <span>地 &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;址:</span>
                <input type="text" style="width: 80%" disabled v-model="users.site"/>
              </li>
              <li>
                <span>电 &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;话:</span>
                <input type="text" disabled v-model="users.consignee_phone"/>
              </li>
              <li>
                <span>邮 &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;箱:</span>
                <input type="text" disabled v-model="users.email"/>
              </li>
            </ul>
          </div>
          <div style="clear: both"></div>
          <div>
            甲、乙双方经友好协商，本着自愿、平等、诚信的原则，就乙方接受甲方视力调理服务相关事宜，达成以下协议内容，以资共同遵守。<br>
            <b>第一条 服务事项</b><br>
            1、甲方将根据乙方的视力情况，为其定制视力调理方案：按周期进行眼部贴敷按摩调理。<br>
            2、乙方接受调理服务前的视力状况为：（裸视力）R:<input type="text" class="input_2" disabled  v-model="hy.right"/>
            L:<input type="text" class="input_2" disabled  v-model="hy.left"/>    。<br>
            <b>第二条 权利与义务</b><br>
            1、为保证视力调理效果，乙方应严格按照甲方制定的调理周期及方案接受调理服务，并配合甲方工作人员进行视力检测、评估等。<br>
            2、乙方保证向甲方如实陈述自身的视力健康状况如有散光、弱视及其他眼疾等或皮肤过敏史或其他不适症状等应书面告知甲方，因乙方隐瞒健康状况导致调理过程中出现的身体不适或调理结果不理想等，甲方不承担责任。<br>
            3、乙方应按照本协议约定的收费标准向甲方支付视力调理服务费用。<br>
            <b>第三条 服务费用</b><br>
            1、视力调理服务费用单次为人民币<input type="text" class="input_2" disabled  v-model="hy.avg_price"/> 元，
            共<input type="text" class="input_2" disabled  v-model="hy.s_keshu"/> 次，
            实收总价为人民币：<input type="text" class="input_2" disabled :value="hy.shishou"/> 元（大写：<input type="text" disabled class="input_2" style="width: 150px"  :value="hy.shishou_a"/> 圆整）。
            本协议签订当日乙方将前述费用一次性支付至甲方指定账户。<br>
            2、退费条款：若乙方经过三日连续按摩调理后，视力状况无任何改善且视力表检测数据较乙方接受调理前未提升的，甲方同意退还乙方已付服务费用。若因乙方自身原因未按照甲方制定的方案连续三日接受调理服务或接受调理服务超过三次后，则乙方无权要求甲方退还服务费用。<br>
            <b>第四条 争议解决</b><br>
            执行本协议过程中的任何争议，双方应友好协商解决；若协商不成，任何一方均有权将争议提交至甲方所在地有管辖权的法院解决。<br>
            <b>第五条 其他</b><br>
            1、本协议有效期自合同签署后<input type="text" disabled class="input_2" :value="hy.expiration_date"/>个月内有效，合同有效期届满后服务项目终止。<br>
            2、本协议自双方签字盖章之日起生效，协议一式两份，甲、乙双方各执一份，具有同等法律效力。<br>
            <table>
              <tr style="height: 55px;">
                <td><b>甲方(盖章)：</b></td>
                <td><b>乙方(签字)：</b></td>
              </tr>
              <tr>
                <td>签署日期：{{hy.create_time}}</td>
                <td>签署日期：{{hy.create_time}}</td>
              </tr>
            </table>

          </div>
        </div>
      </div>
			<div class="clearfix printBtn" style="margin-top: 20px;text-align:center">
				<el-button @click="doPrint(1)" type="warning" round>打印合同</el-button>
			</div>
      <el-dialog title="温馨提示" :visible.sync="showalert2" width="30%" center :close-on-click-modal="false" >
        <div style="text-align: center;vertical-align: middle;padding-top: 30px">
          <img src="/static/qmsj/img/newcontract/tanhao.png" style="vertical-align: middle" height="20" width="20" alt="">
          <span style="font-size: 20px;vertical-align: middle" v-if="show_what">打印完成,返回会员列表</span>
          <span style="font-size: 20px;vertical-align: middle" v-if="!show_what && type_link== 2">打印完成,返回潜客跟进</span>
          <span style="font-size: 20px;vertical-align: middle" v-if="!show_what && type_link== 3">打印完成,返回会员跟进</span>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button class="btnfont" v-if="show_what" type="warning" style="background: #E6BE8A;color: #ffffff;width: 100px;padding: 10px;border-radius: 30px;" @click="showback2">确 定</el-button>
					<el-button class="btnfont" v-if="!show_what && type_link== 2" type="warning" style="background: #E6BE8A;color: #ffffff;width: 100px;padding: 10px;border-radius: 30px;" @click="showback3">确 定</el-button>
					<el-button class="btnfont" v-if="!show_what && type_link== 3" type="warning" style="background: #E6BE8A;color: #ffffff;width: 100px;padding: 10px;border-radius: 30px;" @click="showback4">确 定</el-button>
				</span>
      </el-dialog>
		</div>

	</div>
</template>

<script>
	import purBtn from '@/components/btn.vue'
	import weitap from '@/components/weitap'
	export default {
		components: {
			purBtn,
			weitap
		},
		data() {
			return {
				showalert: false,
				showalert2: false,
				jl_id: '',
				users: [],
				hy: [],
				centre_info: '',
        centre_id:0,
				token: '',
				cd_ren:'',
				type_link:'',
				show_what:true
			}
		},
		mounted() {
			//            this.jl_id = this.getQueryVariable('id');
			let self = this;
			self.token = $.cookie('token');
			self.jl_id = this.$route.query.id;
			self.type_link = this.$route.query.type;
			if(self.type_link == 2 || self.type_link == 3){
			    self.show_what = false;
			}
			self.get_info()
		},
    filters: {
      numFilter(value) {
        if (value) {
          // 截取当前数据到小数点后两位
          let realVal = parseFloat(value).toFixed(2)
          return realVal
        } else {
          return 0
        }

      }
    },
		methods: {
			// showback() {
			// 	this.showalert = false;
			// 	$('#wrap').hide();
			// 	$('#content').show();
			// 	// alert("请继续打印合约背面");
			// 	this.doPrint(2)
			// },
			showback2() {
				this.$router.push('huiyuan')
			},
      showback3() {
          this.$router.push('qianke')
      },
      showback4() {
          this.$router.push('vip')
      },
			getQueryVariable(variable) {
				var query = window.location.search.substring(1);
				var vars = query.split("&");
				for (var i = 0; i < vars.length; i++) {
					var pair = vars[i].split("=");
					if (pair[0] == variable) {
						return pair[1];
					}
				}
				return (false);
			},
			// type: 1-打印正面；  2-打印背面
			doPrint(type) {
				print.portrait=true
				window.print();
				if (type === 1) {
					this.showalert2 = true;
				}
				// if (type === 2) {
				// 	this.showalert2 = true;
				// 	console.log(11111,this.showalert2  )
				// }
			},
			get_info() {
				let self = this;
				$.ajax({
					'type': 'post',
					'url': process.env.apiUrl + "saas/user/show_con",
					'data': {
						'jl_id': self.jl_id,
						'token': self.token
					},
					'success': function(data) {
						if (data.status == 1) {
							// self.$refs.qrcode.src = data.qrcode
							self.users = data.users;
							self.hy = data.hy
							self.cd_ren=data.cd_ren
							self.centre_info = data.centre_info;
              self.centre_id = data.centre_id
							setTimeout(function() {
								self.doPrint(1)
							}, 1000)

						} else {
							self.$message({
								'msg': data.msg,
								'type': 'error'
							})
							// self.jback();
						}
					}
				})
			}
		}

	}
</script>
<style lang="less">
.show_con {
	.el-dialog__close,
	.el-dialog__header {
		color: #fff!important;
	}
	.el-dialog__headerbtn:hover .el-dialog__close {
		color: #fff!important;
	}
}
</style>
<style media="print">
	@page {
		size: auto;
		/* auto is the initial value */
		margin: 0mm;
		/* this affects the margin in the printer settings */
	}
</style>
<style scoped>
	.head {
		padding: 10px 45px 0;
		display: flex;
		display: -webkit-flex;
		justify-content: space-between;
		border-bottom: 1px solid #bdb8e0;
	}

	* {
		font-size: 16px;
		margin: 0;
		padding: 0;
	}

	[v-cloak] {
		display: none;
	}

	li {
		list-style: none;
	}

	body {
		margin: 30px 40px;
	}

	#wrap {
		width: 210mm;
		height: 294mm;
		border: 1px solid gainsboro;
		padding: 15px 50px 15px 0;
		box-sizing: border-box;
	}

  .header .title {
    font-size: 21px;
    font-weight: bold;
    text-align: center;
  }

	.header .right {
		display: inline-block;
		font-weight: bold;
		font-size: 18px;
		float: right;
	}

	.small-titlee span {
		display: inline-block;
		margin-top: 58px;
		margin-left: 5px;
		margin-bottom: 14px;
	}

	.small-titlee ul {
		float: right;
		margin-right: 3px;
	}

	.small-titlee input {
		border: 0;
		border-bottom: 1px solid;
		outline: none;
		padding-left: 11px;
		width: 100px;
	}
  .input_2{
    width: 80px;
    border: 0;
    border-bottom: 1px solid;
    margin: 0px 5px;
    padding:0px 10px;
  }
  .information {
    margin-left: 6px;
  }

  .information ul {
    width: 98%;
    display: inline-block;
  }

  .information li {
    width: 48%;
    margin-top: 9px;
    float: left;
  }

  .information input {
    border: 0;
    border-bottom: 1px solid;
    outline: none;
    padding-left: 11px;
    width: 210px;
  }

  .information li span {
    letter-spacing: 2px;
  }


	.infant {
		margin-left: 5px;
		margin-top: 5px;
	}

	.infant .n_input {
		border: 0;
		border-bottom: 1px solid;
		outline: none;
		padding-left: 11px;
		width: 60px;
	}

	.infant .t_input {
		border: 0;
		border-bottom: 1px solid;
		outline: none;
		padding-left: 11px;
		width: 30px;
	}

	.infant .add {
		display: inline-block;
		width: 14px;
		height: 14px;
		line-height: 13px;
		text-align: center;
		border: 1px solid black;
		border-radius: 50%;
		cursor: pointer;
	}

	.infant label {
		margin-left: 25px;
	}

	.infant input {
		vertical-align: middle;
	}

	.infant .titlee {
		/*margin: 13px 0 5px 0;*/
		font-weight: bold;
	}

	.ul_list {
		position: absolute;
		background-color: rgb(255, 255, 255);
		z-index: 999;
		border: 1px solid gray;
		padding: 3px 10px 8px;
		width: 90px;
		text-align: center;
		margin-top: 5px;
		margin-left: 40px;
	}

	.ul_list li span {
		float: left;
		cursor: pointer;
		width: 50%;
		margin-top: 5px;
	}

	.content {
		margin-left: 5px;
	}

	.content .line {
		margin-top: 5px;
	}

	.content .titlee {
		font-weight: bold;
		margin-top: 10px;
		margin-bottom:3px;
	}

	.content table {
		width: 100%;
	}

	.content .one-table td {
		text-align: center;
	}

	.one-table .tr td {
		width: 12%;
		padding:6px 0;
	}

	.content .sel {
		margin-top: 20px;
		padding-left: 5px;
		padding-right: 30px;
	}

	.content .two-table div {
		padding: 6px 0 6px 15px;
		border-top: 1px solid black;
	}

	.content .two-table textarea {
		margin-left: 14px;
		width: 92%;
		height: 58px;
		margin-top: 24px;
		padding: 6px 10px;
		box-sizing: border-box;
		outline: none;
	}

	.content div:first-child {
		border: 0;
	}

	.three-table td,
	th {
		text-align: center;
		padding: 6px 0;
	}

	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 130px;
	}

	.el-input--prefix .el-input__inner {
		border-color: gainsboro;
	}

	.el-radio__input.is-checked .el-radio__inner {
		border-color: gainsboro;
		background: gray;
	}

	.el-radio__input.is-checked+.el-radio__label {
		color: black;
	}

	/*.el-dialog__body {*/
	/*position: relative;*/
	/*padding: 0;*/
	/*}*/

	.el-dialog__header {
		background: #E6BE8A;
		color: #FFFFFF;
	}

	.el-dialog__title {
		color: #FFFFFF;
		font-size: 22px;
	}

	.btnfont>span {
		font-size: 18px;
	}

	.dia_header {
		padding: 12px 12px 12px 30px;
		background-color: gainsboro;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
	}

	.search_inp {
		height: 24px;
		margin-left: 30px;
		padding-left: 10px;
		outline: none;
		border: 1px solid gray;
		border-radius: 2px;
		margin-right: 5px;
	}

	.search_sel {
		height: 26px;
		padding-right: 10px;
		padding-left: 5px;
	}

	.el-input-number--mini {
		width: 100px;
	}

	.el_close {
		color: rgb(255, 255, 255);
		font-size: 24px;
		float: right;
		padding-right: 18px;
		cursor: pointer;
	}

	.el-button {
		padding: 6px 10px;
	}

	.el-button:active {
		color: gray;
		border-color: grey;
	}

	.el-button:hover {
		color: gray;
		border-color: grey;
		background-color: gainsboro;
	}

	.el-pager li.active {
		color: gray;
	}

	.el-pager li:hover {
		color: gray;
	}

	.input_num {
		width: 60px;
		height: 23px;
		text-align: center;
		border: 1px solid grey;
		border-radius: 3px;
	}

	.el-table td,
	.el-table th {
		padding: 6px 0;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: gainsboro;
		border-color: gray;
	}

	input[]:invalid,
	input:focus:invalid,
	textarea[]:invalid,
	textarea:focus:invalid {
		box-shadow: none;
	}

	#content {
		width: 210mm;
		height: 294mm;
		padding: 15px 50px 15px 0;
		box-sizing: border-box;
	}

	.el-dialog__headerbtn {
		display: none;
	}

	.right_bottom {
		display: none !important;
	}

	.topbar,
	.right_top,
	.navbar-box {
		display: none !important;
	}
	div.gift-wrap {
		display: flex;
		flex-wrap: wrap;
		margin-top:20px;
		border:none!important;
		max-width: 50%;
	}
	.qrcode-wrap {
		position: absolute;
		top: 0;
		right: 0;
		border-left: 1px solid #000!important;
		width: 50%;
		min-height: 110%;
		height: 154px;
		text-align: center;
		background: #fff!important;
	}
	.qrcode-wrap p {
		font-size: 16px;
		line-height: 30px;
		text-align: center;
	}
	.qrcode-wrap img {
		width: 110px;
	}

	@media print {
		.printBtn {
			display: none;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/huiyuan/show_con.vue